import { useQuery } from '@tanstack/react-query';
import { roomWantedApi } from '../api/roomWanted.api';
import { roomWantedKeys } from '../api/roomWanted.keys';

export function useRoomWantedDetails(id: any) {
  return useQuery({
    queryKey: roomWantedKeys.detail(id),
    queryFn: () => roomWantedApi.getById(id),
    enabled: !!id,
  });
}
